import { render, staticRenderFns } from "./ConnectedPage.vue?vue&type=template&id=035840b4&"
import script from "./ConnectedPage.vue?vue&type=script&lang=js&"
export * from "./ConnectedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports